import React from "react";

export const SectionSeparator = () => (
  <tr>
    <td colSpan={2} className="border-top py-1" />
  </tr>
);

export default SectionSeparator;
